import React from 'react'
import { FetchResult } from '@apollo/client'

import { Dropdown } from '@sketch/components'
import {
  usePinShareMutation,
  useUnpinShareMutation,
  PinShareMutation,
  UnpinShareMutation,
} from '@sketch/gql-types'
import { ClientOrCache } from '@sketch/graphql-cache'
import { ReactComponent as PinIcon } from '@sketch/icons/pushpin-17'

export interface VersionsForDropdown {
  current: { shortId: string }
  latest: { shortId: string }
}

export interface PinDocumentProps {
  shareIdentifier: string
  pinned: boolean
  update?: (
    cache: ClientOrCache,
    data: FetchResult<PinShareMutation> | FetchResult<UnpinShareMutation>
  ) => void
}

export const PinDocument = ({
  update,
  shareIdentifier,
  pinned,
}: PinDocumentProps) => {
  const [pinShare] = usePinShareMutation({
    variables: {
      shareIdentifier,
    },
    onError: 'show-toast',
    update,
  })

  const [unpinShare] = useUnpinShareMutation({
    variables: {
      shareIdentifier,
    },
    onError: 'show-toast',
    update,
  })

  return (
    <Dropdown.Item
      icon={<PinIcon />}
      onClick={() => {
        if (pinned) {
          return unpinShare({ variables: { shareIdentifier } })
        }
        return pinShare({ variables: { shareIdentifier } })
      }}
    >
      {pinned ? 'Unpin Document' : 'Pin Document'}
    </Dropdown.Item>
  )
}
